module.exports = __webpack_public_path__ + "img/fi-rr-pencil.673d36e1.svg";